import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var FileFolderIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("g", {
                            clipPath: "url(#file-folder__a)",
                            children: _jsx("path", {
                                d: "M3.903 23.345c-.64 0-1.25-.24-1.73-.66-.48-.43-.78-1.03-.85-1.67v-.04l-.66-11.15c-.03-.19 0-.45.07-.69.08-.24.21-.47.38-.66.17-.19.38-.34.61-.44.23-.1.46-.16.74-.15h7.33c.4 0 .79.14 1.11.38.31.24.54.59.64.97l.45 1.84h9.56c.25 0 .49.05.72.15.23.1.43.24.6.42.17.19.3.4.38.63.08.24.11.48.09.73l-.62 7.96a2.56 2.56 0 01-.83 1.7c-.48.44-1.12.65-1.77.68H3.903zm-.58-2.52c.02.14.09.27.19.36.11.1.26.11.4.15h16.24c.13-.01.3-.05.41-.16.11-.1.18-.24.19-.39l.6-7.74h-10.13c-.46 0-.86-.31-.97-.76l-.6-2.42h-6.97l.64 10.95v.01zm18.25-11.02c-.55 0-1-.45-1-1v-6.16H7.443v2.98c0 .55-.45 1-1 1s-1-.45-1-1v-3.18c0-.47.19-.94.53-1.27a1.8 1.8 0 011.27-.52h13.53c.24 0 .47.05.69.14.22.09.42.22.58.39a1.81 1.81 0 01.53 1.27v6.37c0 .55-.45 1-1 1v-.02z"
                            })
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "file-folder__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
FileFolderIcon.isCarinaIcon = true;
export default FileFolderIcon;
